module.exports = __webpack_public_path__ + "static/media/mockup.27ebd31b.jpg";